import api from '../../../../App/socket';
import { PURCHASING_API } from '../../../../../common/constants/api';
import config from '../../../../../config/sbf_config';
import { getErrorMessage } from '../../../../../shared/helpers';
import { leadsServiceApi } from '../../../../../infra/purchasingApi.service';

export const updateBlemishReport = async (params, params2) => {
    // lead_id, leadQuestion, updateValue, note, deduction, approved

    if (params.updateValue) {
        if (params.updateValue === 'true') {
            params.updateValue = true;
        } else if (params.updateValue === 'false') {
            params.updateValue = false;
        }
    }

    if (config.featureToggles.leadBlemishReport) {
        const question = {
            [params.question]: {
                value: params.updateValue,
                note: params.note,
                deduction: params.deduction,
            }
        };

        try {
            const res = await leadsServiceApi({
                method: 'patch',
                url: `${PURCHASING_API.LEADS}/${params.lead_id}/lead-blemish-report`,
                data: { questions: params.questions || question }
            });

            return {
                result: true,
                options: res.data
            }
        } catch (e) {
            return {
                msg: getErrorMessage(e),
                error: e
            };
        }
    }

    if (!params2) {
        params2 = {};
    }

    const question = {
        [params.question]: {
            value: params.updateValue,
            note: params.note,
            marked_additional_requirements: params.marked_additional_requirements,
            deduction: params.deduction || null,
        },
        ...params2,
    };

    return api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'Update_Lead_blemish_report',
        options: {
            where: {
                ref_lead: params.lead_id,
            },
            update: {
                questions: params.questions || question,
                price_negotiate: params.price_negotiate,
            },
        },
    });
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/leads_questions/update_blemish_report_request.js